(function() { window.GUID_9f6f9147_b479_43ac_8afe_1e222b20f645 = { getGuid: function() { return "9f6f9147-b479-43ac-8afe-1e222b20f645"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class OpponentsSection {
                        static get instance() {
                            if (!OpponentsSection._instance)
                                OpponentsSection._instance = new OpponentsSection();
                            return OpponentsSection._instance;
                        }
                        static get filtersUIFreezed() {
                            const { instance } = OpponentsSection;
                            return instance._filtersUIFreezed;
                        }
                        static get filtersAreCollapsed() {
                            const { instance } = OpponentsSection;
                            return instance._filtersAreCollapsed;
                        }
                        static get showGlobalRank() {
                            const { instance } = OpponentsSection;
                            return instance._showGlobalRank;
                        }
                        static get showTeamRoster() {
                            const { instance } = OpponentsSection;
                            return instance._showTeamRoster;
                        }
                        static get isWallLayout() {
                            return $("#OpponentsV2WallLayout").val() == "True";
                        }
                        static get minCSR() {
                            const { instance } = OpponentsSection;
                            return instance._minCSR;
                        }
                        static get maxCSR() {
                            const { instance } = OpponentsSection;
                            return instance._maxCSR;
                        }
                        constructor() {
                            this.rankScope = "local";
                            this._filtersUIFreezed = true;
                            this._filtersAreCollapsed = true;
                            this._showGlobalRank = false;
                            this._showTeamRoster = null;
                            this._minCSR = null;
                            this._maxCSR = null;
                            this._observers = [];
                        }
                        static setRankScope(scope, checkox) {
                            const { instance } = this;
                            const $globalRanks = $(".opponent .rank.global-rank");
                            const $localRanks = $(".opponent .rank.local-rank");
                            if (!scope)
                                scope = OpponentsSection.showGlobalRank ? "global" : "local";
                            instance.rankScope = scope;
                            if (!checkox) {
                                checkox = CS.Controls.GetInstance(CS.Controls.CheckBox, "#checkbox-leaderboard-rank-scope", true);
                            }
                            if (checkox) {
                                const value = checkox.GetValue();
                                const isSynced = scope == "global" ? value == "true" : value != "true";
                                if (!isSynced) {
                                    checkox.SetValue(scope == "global" ? true : false);
                                }
                            }
                            switch (scope) {
                                case "global":
                                    instance._showGlobalRank = true;
                                    $globalRanks.css({ display: "" });
                                    $localRanks.css({ display: "none" });
                                    break;
                                case "local":
                                    instance._showGlobalRank = false;
                                    $localRanks.css({ display: "" });
                                    $globalRanks.css({ display: "none" });
                                    break;
                                default:
                            }
                        }
                        static setObservers(accordion) {
                            const { instance } = this;
                            OpponentsSection.clearObservers();
                            //const $stickyTopContent = accordion.$Content.find(".sticky-top-content");
                            //if ($stickyTopContent.length) {
                            //    let topHeight = CS.Views.MasterPage.TopHeight - 1;
                            //    $stickyTopContent.css({
                            //        position: "sticky",
                            //        top: `${topHeight}px`,
                            //        zIndex: 17,
                            //    });
                            //}
                            const $filters = accordion.$Content.find(".filters");
                            const $toolbar = accordion.$Content.find(".toolbar");
                            const $globalRankToggleSwitch = accordion.$Content.find(".leaderboard-rank-scope-toggle-container");
                            if ($filters.length && $toolbar.length) {
                                const $topbar = $("#section-top");
                                const $bottomBar = $("#section-bottom");
                                const topHeight = $topbar.outerHeight();
                                const bottomHeight = $bottomBar.outerHeight();
                                const isLeaderboardFormat = $toolbar.hasClass("sticky-toolbar");
                                instance._observers.push(new CS.Helper.CSIntersectionObserver($filters, topHeight, bottomHeight), new CS.Helper.CSIntersectionObserver($toolbar, topHeight, bottomHeight));
                                $topbar.addClass("no-box-shadow");
                                $topbar.addClass("with-border-bottom");
                                let toolbarWasVisible = true;
                                const $chips = accordion.$Content.find(".chips");
                                $chips.css({
                                    top: `${Math.floor(topHeight) - 1}px`,
                                });
                                $chips.removeClass("hiddenforced");
                                if (isLeaderboardFormat) {
                                    CS.Lag("update-toolbar-top__", 100, () => {
                                        let chipsHeight = 0;
                                        if ($chips.length) {
                                            chipsHeight = CS.Helper.GetHeightOfHiddenElement($chips, "width-infinite");
                                        }
                                        if (accordion.customNumberA == null) {
                                            // Nécessaire puisque la valeur de "chipsHeight" semble instable après le premier refresh..
                                            accordion.customNumberA = chipsHeight;
                                        }
                                        // Pour le cas où il y avait des chips, mais qu'il n'y en a plus après le refresh
                                        const toolbarTop = chipsHeight > 1
                                            ? Math.floor(topHeight + chipsHeight) - 1
                                            : Math.floor(topHeight) - 1;
                                        $toolbar.css({
                                            position: "sticky",
                                            top: `${toolbarTop}px`,
                                            "z-index": 10,
                                        });
                                        if ($globalRankToggleSwitch.length) {
                                            const globalRankToggleSwitchTop = toolbarTop + $toolbar.outerHeight() - 1;
                                            $globalRankToggleSwitch.css({
                                                position: "sticky",
                                                top: `${globalRankToggleSwitchTop}px`,
                                                "z-index": 10,
                                            });
                                        }
                                    });
                                }
                                const onToolbarVisible = () => {
                                    //$chips.addClass("hiddenforced");
                                    //$chips.addClass("xyz-out");
                                    //$chips.removeClass("xyz-in");
                                    toolbarWasVisible = true;
                                };
                                const onToolbarPartiallyHidden = (hiddenRatio, invertedHiddenRatio) => {
                                    if (toolbarWasVisible) {
                                        //$chips.addClass("hiddenforced");
                                        //$chips.addClass("xyz-out");
                                        //$chips.removeClass("xyz-in");
                                    }
                                };
                                const onToolbarHidden = () => {
                                    //$chips.removeClass("hiddenforced");
                                    //$chips.removeClass("xyz-out");
                                    //$chips.addClass("xyz-in");
                                    toolbarWasVisible = false;
                                };
                                if (!isLeaderboardFormat) {
                                    instance._observers[1].observeTopIntersections(`${accordion.ControlId}-chips`, onToolbarVisible, onToolbarPartiallyHidden, onToolbarHidden);
                                }
                                const onFiltersVisible = () => {
                                    $topbar.addClass("no-box-shadow");
                                    $topbar.addClass("with-border-bottom");
                                    if (isLeaderboardFormat)
                                        onToolbarVisible();
                                };
                                const onFiltersPartiallyHidden = (hiddenRatio, invertedHiddenRatio) => {
                                    $topbar.addClass("no-box-shadow");
                                    $topbar.addClass("with-border-bottom");
                                    if (isLeaderboardFormat)
                                        onToolbarVisible();
                                };
                                const onFiltersHidden = () => {
                                    $topbar.removeClass("no-box-shadow");
                                    $topbar.removeClass("with-border-bottom");
                                    if (isLeaderboardFormat)
                                        onToolbarHidden();
                                };
                                instance._observers[0].observeTopIntersections(`${accordion.ControlId}-filters`, onFiltersVisible, onFiltersPartiallyHidden, onFiltersHidden);
                            }
                        }
                        static toggleCustomPresetVisibility(visibilityCondition) {
                            const $dropdown = $("#dropdown-opponents-wall-presets");
                            if ($dropdown.length) {
                                const $customPresetItem = $dropdown.find(`.list-item[data-value='${CS.Enumeration.OpponentsFiltersPreset.Custom}']`);
                                if ($customPresetItem.length) {
                                    if (visibilityCondition)
                                        $customPresetItem.removeClass("hiddenforced");
                                    else
                                        $customPresetItem.addClass("hiddenforced");
                                }
                            }
                        }
                        static updateFiltersState(state, $elementsContainer, $elementsToToggle, callback) {
                            if (state == "collapsed") {
                                $elementsToToggle.slideUp(150, () => {
                                    if (callback)
                                        callback.call(this);
                                });
                            }
                            else if (state == "expanded") {
                                $elementsToToggle.slideDown(150, () => {
                                    if (callback)
                                        callback.call(this);
                                });
                            }
                            if (state == "collapsed")
                                CS.Lag("opponents-wall-toggle-filters", 75, () => $elementsContainer.addClass("collapsed"));
                            else
                                CS.Lag("opponents-wall-toggle-filters", 75, () => $elementsContainer.removeClass("collapsed"));
                        }
                        static removeLazyloadingTrigger(accordion) {
                            accordion.$Content.find(".button-lazy-loader-trigger").remove();
                            accordion.$Content.find(".lazy-loader-trigger").remove();
                        }
                        static extractData(extraData, accordion) {
                            const { isCurrent, url: baseUrl, isDisabled, snackbarMessage, } = extraData;
                            const url = OpponentsSection.formatSectionUrl(baseUrl, accordion);
                            return {
                                url,
                                isCurrent,
                                isDisabled,
                                snackbarMessage,
                            };
                        }
                        static formatSectionUrl(url, accordion) {
                            const collapsedStateInUrl = url.indexOf("filtersState=Collapsed") > -1;
                            const collapsedStateFits = collapsedStateInUrl == OpponentsSection.filtersAreCollapsed;
                            if (!collapsedStateFits) {
                                if (OpponentsSection.filtersAreCollapsed) {
                                    url = url.replace("filtersState=Expanded", "filtersState=Collapsed");
                                }
                                else {
                                    url = url.replace("filtersState=Collapsed", "filtersState=Expanded");
                                }
                            }
                            const showTeamRosterIsInUrl = url.indexOf("showTeamRoster") > -1;
                            if (OpponentsSection.showTeamRoster != null) {
                                if (showTeamRosterIsInUrl) {
                                    const showTeamRosterInUrl = url.indexOf("showTeamRoster=True") > -1;
                                    const teamRosterValueFits = showTeamRosterInUrl == OpponentsSection.showTeamRoster;
                                    if (!teamRosterValueFits) {
                                        if (OpponentsSection.showTeamRoster) {
                                            url = url.replace("showTeamRoster=False", "showTeamRoster=True");
                                        }
                                        else {
                                            url = url.replace("showTeamRoster=True", "showTeamRoster=False");
                                        }
                                    }
                                }
                                else {
                                    url += `\u0026showTeamRoster=${OpponentsSection.showTeamRoster ? "True" : "False"}`;
                                }
                            }
                            else if (showTeamRosterIsInUrl) {
                                url = url.replace("\u0026showTeamRoster=True", "");
                                url = url.replace("\u0026showTeamRoster=False", "");
                            }
                            else {
                                // showTeamRoster == null and is not in URL
                            }
                            url += "&wallLayout=True";
                            return url;
                        }
                        static updateUI(accordion) {
                            OpponentsSection.updateTeamRosterVisibility(accordion);
                            const { instance } = OpponentsSection;
                            const $stickyTopContent = accordion.$Content.find(".sticky-top-content");
                            if ($stickyTopContent.length) {
                                let topHeight = CS.Views.MasterPage.TopHeight - 1;
                                $stickyTopContent.css({
                                    position: "sticky",
                                    top: `${topHeight}px`,
                                    zIndex: 17,
                                });
                            }
                            OpponentsSection.setLazyloadingUrl(accordion);
                            const $filtersCounter = CS.DOM.$topBar.find(".filters");
                            if ($filtersCounter.length) {
                                const filtersCounterHtml = $filtersCounter.html();
                                const index = filtersCounterHtml.indexOf("(") + 1;
                                const filtersCount = $("#OpponentsV2ActiveFilters").val();
                                if (filtersCount != null) {
                                    const newFiltersCounterHtml = filtersCounterHtml.substring(0, index) +
                                        filtersCount +
                                        filtersCounterHtml.substring(index + 1);
                                    const opacity = filtersCount == 0 ? 0 : 1;
                                    CS.DOM.$topBar
                                        .find(".filters")
                                        .html(newFiltersCounterHtml)
                                        .css({ opacity: opacity });
                                }
                            }
                            const $lazyLoadingTrigger = accordion.$Content.find(".button-lazy-loader-trigger");
                            if ($lazyLoadingTrigger.length)
                                CS.Lag(`${accordion.ControlId}-lazyload`, 500, () => $lazyLoadingTrigger.trigger("click"));
                            const $chipsVisibilityTrigger = accordion.$Content.find(".toolbar");
                            const $chips = accordion.$Content.find(".chips");
                            if ($chips.length)
                                $chips.removeClass("hiddenforced");
                            OpponentsSection.setObservers(accordion);
                        }
                        static setLazyloadingUrl(accordion) {
                            const $lazyloadingUrl = $("#LazyloadingUrl");
                            if ($lazyloadingUrl.length)
                                accordion.Data.RefreshUrl = $lazyloadingUrl.val();
                        }
                        static updateTeamRosterVisibility(accordion) {
                            const { instance } = OpponentsSection;
                            const $showTeamRosterCheckbox = $("#checkbox-show-team-roster");
                            if ($showTeamRosterCheckbox.length) {
                                const checkbox = CS.Controls.GetInstance(CS.Controls.CheckBox, $showTeamRosterCheckbox, true);
                                if (checkbox != null) {
                                    const checkboxValue = checkbox.GetValue().toLowerCase() == "true";
                                    instance._showTeamRoster = checkboxValue;
                                }
                                else {
                                    // Le control du checkbox est parfois null..
                                    const isChecked = $showTeamRosterCheckbox.hasClass("checked");
                                    instance._showTeamRoster = isChecked;
                                }
                                if (OpponentsSection.showTeamRoster) {
                                    accordion.$Content.addClass("show-team-roster");
                                }
                                else {
                                    accordion.$Content.removeClass("show-team-roster");
                                }
                            }
                            else {
                                instance._showTeamRoster = null;
                            }
                        }
                        static clearObservers() {
                            const { instance } = OpponentsSection;
                            const { _observers } = instance;
                            if (_observers != null && _observers.length > 0) {
                                for (const key in _observers) {
                                    if (_observers[key]) {
                                        _observers[key].stopObservingTopIntersections();
                                        _observers[key] = null;
                                    }
                                }
                            }
                            instance._observers = [];
                        }
                        static appendFiltersCounterInTopBar() {
                            try {
                                //let filtersCount = $("#OpponentsV2ActiveFilters").val();
                                //if (filtersCount == null) {
                                //    filtersCount = $("#ActiveFiltersCount").val();
                                //}
                                //if (filtersCount == null) filtersCount = 0;
                                //const opacity = filtersCount == 0 ? 0 : 1;
                                //const html = `<div class="filters" style="opacity: ${opacity};">
                                //        <div class="icon ic-cs-filter" data-html=""></div>&nbsp;<span class="label">(${filtersCount})</span>
                                //    </div>`;
                                //let $container = DOM.$topBar.find(
                                //    ".event-dropdown-picker .current-event__name .label"
                                //);
                                //if (!$container.length) {
                                //    $container = DOM.$topBar.find(
                                //        ".topbar-title-container .topbar-title"
                                //    );
                                //}
                                //if ($container.length) {
                                //    $container.append(html);
                                //}
                            }
                            catch (e) {
                                console.log(e);
                            }
                        }
                    }
                    WallSections.OpponentsSection = OpponentsSection;
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=opponents-section.js.map
